export default "__VITE_ASSET__CbzSLUf1__"